
const registration = { 
  step_one: {
    title: 'Let’s register your business',
    content: 'Setup your business and let\'s start working together',
  },
  step_two: {
    title: 'Contact person',
    content: 'This is the person who may be managing the store or anybody we can contact easily',
  },
  step_three: {
    title: 'Set your password',
    content: 'Set a strong password to enhance the security of your account',
    consent: {
      1: 'By clicking Sign up, I agree that I have read and accepted the ',
      2: 'Terms of Use',
      3: ' and ',
      4: 'Privacy Policy'
    },
  },
  forgot_password: {
    title: 'Forgot password',
    content: 'Enter your registered email address and we’ll send you a  password reset link that will enable you to reset your password'
  },
  field: {
    bname: 'Business name',
    bmail: 'Business email address',
    fname: 'First name',
    lname: 'Last name',
    email: 'email address',
    country: 'Select country',
    category: 'Select category',
    phone: 'Phone number',
    password: 'Password',
    password_confirmation: 'Repeat password',
  },
  password: 'Password',
  signup: 'Signup',
  success: 'New merchant created successfully',
  forgot: 'Forgot password',
  signin: 'Sign in',
  register: 'Don\'t have an account?',
  registered: 'Already have an account?',
  welcome: '',
  tc: 'Terms & Conditions'
};

export default registration;